import React, { useEffect, useRef } from 'react'
import styles from './KeyDropAccess.module.css'
import { useSelector } from 'react-redux';
import { AppDispatch, IRootState } from '../redux/rootReducer';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getLocationPublicDetailsById } from '../redux/location/actions/location.action';
import Loader from '../components/common/loader/Loader';
import KeyPickupDropAccessModal from '../components/keyPickupDropAccessModal/KeyPickupDropAccessModal';
const KeyDropAccess = () => {
  const dispatch: AppDispatch = useDispatch();
  const hasCalledAPI = useRef(false);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id && !hasCalledAPI.current) {
      hasCalledAPI.current = true;
      dispatch(getLocationPublicDetailsById(id));
    }
    // return () => {
    //   // dispatch(clearVendorAppointmentsState());
    // }
  }, [id, dispatch]);

  const { data: locationData, loading: locationLoading } = useSelector((state: IRootState) => state.locationReducer.locationPublicDetails);
  return (
    <div
      className={`${styles.container}  ${styles.propertyImageWrapper}`}
      style={{
        backgroundImage: `url(${locationData?.data?.images[0]})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        width: "100%",
      }}
    >
      {locationLoading ? <Loader /> : <KeyPickupDropAccessModal />}
    </div >
  )
}

export default KeyDropAccess
